var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66669C5.3915 1.66669 1.6665 5.39169 1.6665 10C1.6665 14.6084 5.3915 18.3334 9.99984 18.3334C14.6082 18.3334 18.3332 14.6084 18.3332 10C18.3332 5.39169 14.6082 1.66669 9.99984 1.66669ZM14.1665 12.9917L12.9915 14.1667L9.99984 11.175L7.00817 14.1667L5.83317 12.9917L8.82484 10L5.83317 7.00835L7.00817 5.83335L9.99984 8.82502L12.9915 5.83335L14.1665 7.00835L11.1748 10L14.1665 12.9917Z",
    fill: "#6B7280",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.15ab0279c85fe71cf9c3b14bb16a33d9.svg";
export { ForwardRef as ReactComponent };